<template>
  <div :style="{ transform: `translate3d(${coordinates.x}px, ${coordinates.y}px, 0)` }" class="calendar-hover">
    <div class="hover-time f5">{{ time }}</div>
    <svg><use xlink:href="#icon-plus"></use></svg>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    time: {
      type: String,
    },
    coordinates: {
      type: Object,
    },
  },
})
export default class CalendarHover extends Vue {}
</script>

<style lang="postcss" scoped>
@import 'core/shared/styles';

.calendar-hover {
  position: absolute;
  top: 4.6rem;
  left: 0;
  display: flex;
  height: 13rem;
  width: 10rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0;
  padding: 0;
  background-color: rgba(255,255,255,.6);
  cursor: pointer;
  border: 0.3rem var(--colorInfoFlat) dotted;
  border-radius: var(--radius);

  & .hover-time {
    color: var(--colorInfoFlat);
    margin-bottom: var(--spacingXS);
  }

  & svg {
    fill: var(--colorInfoFlat);
    width: 4rem;
    height: 4rem;
  }
}
</style>
